import { lazy, Suspense } from 'react'

import { FeaturesBar } from './components/features-bar'
import { HeroSection } from './components/hero-section'
import { LandingHeader } from './components/landing-header'

import { useLenis } from '@/hooks/use-lenis'

// Seções abaixo do fold — carregadas sob demanda via code splitting
const ClientsMarqueeSection = lazy(() =>
  import('./components/clients-marquee-section').then((m) => ({ default: m.ClientsMarqueeSection })),
)
const PainRecognitionSection = lazy(() =>
  import('./components/pain-recognition-section').then((m) => ({ default: m.PainRecognitionSection })),
)
const ProblemSection = lazy(() =>
  import('./components/problem-section').then((m) => ({ default: m.ProblemSection })),
)
const OfficialSourcesSection = lazy(() =>
  import('./components/official-sources-section').then((m) => ({ default: m.OfficialSourcesSection })),
)
const AuthoritySection = lazy(() =>
  import('./components/authority-section').then((m) => ({ default: m.AuthoritySection })),
)
const BenefitsSection = lazy(() =>
  import('./components/benefits-section').then((m) => ({ default: m.BenefitsSection })),
)
const PackagesSection = lazy(() =>
  import('./components/packages-section').then((m) => ({ default: m.PackagesSection })),
)
const FaqSection = lazy(() =>
  import('./components/faq-section').then((m) => ({ default: m.FaqSection })),
)
const FinalCtaSection = lazy(() =>
  import('./components/final-cta-section').then((m) => ({ default: m.FinalCtaSection })),
)
const LandingFooter = lazy(() =>
  import('./components/landing-footer').then((m) => ({ default: m.LandingFooter })),
)

const noiseTexture =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='240'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"

export function LandingPage() {
  useLenis()

  return (
    <div className="relative min-h-screen font-sans bg-ink-strong">
      <div className="relative z-[1]">
        <LandingHeader />
        <main>
          <HeroSection />
          <FeaturesBar />
          <Suspense fallback={null}>
            <ClientsMarqueeSection />
            <PainRecognitionSection />
            <ProblemSection />
            <OfficialSourcesSection />
            <AuthoritySection />
            <BenefitsSection />
            <PackagesSection />
            <FaqSection />
            <FinalCtaSection />
          </Suspense>
        </main>
        <Suspense fallback={null}>
          <LandingFooter />
        </Suspense>
      </div>
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[2] opacity-[0.04]"
        style={{ backgroundImage: noiseTexture }}
      />
    </div>
  )
}
